import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { blogService, BlogPost, normalizeImagePath } from '../../services/blogService';

const FeaturedStory: React.FC = () => {
  const [story, setStory] = useState<BlogPost | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeatured = async () => {
      try {
        const data = await blogService.fetchFeaturedStory();
        setStory(data);
      } catch (err) {
        console.error('Error fetching featured story:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchFeatured();
  }, []);

  if (loading) {
    return (
      <div className="card h-100">
        <div className="card-body d-flex align-items-center justify-content-center">
          <div className="spinner-border spinner-border-sm text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (!story) {
    return null; // Don't show section if no stories
  }

  return (
    <div className="card h-100 shadow-sm">
      {story.featuredImage && (
        <img
          src={normalizeImagePath(story.featuredImage.path)}
          alt={story.featuredImage.alt || story.title}
          className="card-img-top"
          style={{ height: '180px', objectFit: 'cover' }}
        />
      )}
      <div className="card-body d-flex flex-column">
        <h5 className="card-subtitle text-muted mb-2">
          <i className="fas fa-book-open me-2"></i>From the Road
        </h5>
        <h4 className="card-title">{story.title}</h4>
        <p className="card-text flex-grow-1 text-muted">{story.excerpt}</p>
        <Link to={`/stories/${story.slug}`} className="btn btn-outline-primary">
          Read More
        </Link>
      </div>
    </div>
  );
};

export default FeaturedStory;
